import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type"];
import React, { forwardRef, useMemo } from 'react';
import { DateInput } from "./DateInput";
import { MontInput } from "./MonthInput";
var componentsMap = {
  date: DateInput,
  month: MontInput
};
export var Input = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'date' : _ref$type,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = useMemo(function () {
    return componentsMap[type];
  }, [type]);
  return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    ref: ref,
    "data-t-id": "DatePicker-Input"
  }));
});